import { ModelBase } from 'store/model-base';

import { PlanEligibilityStatus } from 'my-account/constants';
import { Util } from 'core/services/util';

export class DataPlan extends ModelBase {
    public static storeName: string = 'dataPlan';

    public planCode: string;
    public eligibilityStatus: PlanEligibilityStatus;
    public isUnlimited: boolean;
    public inUseOnAccount: boolean;
    public sharedData: number;
    public postSwitch: PlanEligibilityPostSwitch;

    public isEligible: boolean;
    public isIneligibleInUse: boolean;
    public isIneligibleOverage: boolean;
    public isIneligibleBucket: boolean;
    public isIneligibleChangePending: boolean;
    public requiresUpgrade: boolean;
    public sharedDataGB: string;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.isEligible = data.eligibilityStatus === PlanEligibilityStatus.ELIGIBLE;
        data.isIneligibleInUse = data.eligibilityStatus === PlanEligibilityStatus.INELIGIBLE_IN_USE;
        data.isIneligibleOverage = data.eligibilityStatus === PlanEligibilityStatus.INELIGIBLE_OVERAGE;
        data.isIneligibleBucket = data.eligibilityStatus === PlanEligibilityStatus.INELIGIBLE_BUCKET;
        data.isIneligibleChangePending = data.eligibilityStatus === PlanEligibilityStatus.INELIGIBLE_CHANGE_PENDING;
        data.requiresUpgrade = data.eligibilityStatus === PlanEligibilityStatus.REQUIRES_UPGRADE;

        data.isUnlimited = false;
        data.inUseOnAccount = data.inUseOnAccount || false;
        data.sharedDataGB = Util.mbToGb(data.sharedData);

        return super.create<T>(data);
    }
}
